import { Injectable, NgZone, inject } from '@angular/core';
import { App } from '@capacitor/app';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppStateService {
  private readonly zone = inject(NgZone);
  private readonly activeSubject$ = new BehaviorSubject<boolean>(true);

  readonly isActive$: Observable<boolean> = this.activeSubject$.asObservable();

  constructor() {
    void App.addListener('appStateChange', ({ isActive }) => {
      this.zone.run(() => this.activeSubject$.next(isActive));
    });
  }
}
